import script from "./EPlaqueCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EPlaqueCard.vue?vue&type=script&setup=true&lang=ts"

import "./EPlaqueCard.vue?vue&type=style&index=0&id=30095fa6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30095fa6"]])

export default __exports__